<script lang="ts" setup>
/**
 * 投稿者プロフィール回答。
 */
import { defineProps } from "vue";
import { ReviewerAttributeAnswerResponse } from "@/apiRequests/models/reviewerAttributeAnswerResponse";

interface Props {
	/**
	 * 投稿者プロフィール回答取得。
	 */
	reviewerAttributeAnswers: ReviewerAttributeAnswerResponse[];
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<div class="revico-community-talk-user--reviewer-attribute-answer" v-if="reviewerAttributeAnswers.length > 0">
		<ul>
			<li v-for="(answer, i) in reviewerAttributeAnswers" :key="i" :data-revico-reviewer-attribute-display-name="answer.displayName">
				{{ answer.displayName }} : {{ answer.choices.map((x) => x.displayName).join(",") }}
			</li>
		</ul>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-user--reviewer-attribute-answer {
		position: relative;
		top: -5px;
		width: auto;
		display: inline-block;
		text-align: left;
		font-size: 10px;
		color: #909090;
		li {
			display: inline-block;
			&:not(:last-child)::after {
				margin: auto 0.5em;
				content: "/";
			}
		}
	}
}
</style>
